import { Avatar, AvatarGroup, Tooltip } from "@heroui/react";
import lodash from "lodash";

export default function Assignees({
	all,
}: { all: { name: string; avatar: string }[] }) {
	return (
		<AvatarGroup
			isBordered
			max={3}
			radius="lg"
			size="sm"
			className="text-xs min-w-[150px] flex justify-end w-full!"
		>
			{all.map((person: { name: string; avatar: string }) => (
				<Tooltip key={lodash.uniqueId()} content={person.name}>
					<Avatar
						showFallback
						name={person.avatar ? "" : person.name}
						size="sm"
						src={person.avatar}
					/>
				</Tooltip>
			))}
		</AvatarGroup>
	);
}
